<template>

<div class="tab-pane" id="base-justified-task-label" role="tabpanel">

                                        

    <div class="mb-1 mt-1 card-body">
        <div class="two-header">
            <div class="d-flex justify-content-between align-items-center has-line">
                <h5 class="card-title mb-01 text-danger">Open Tasks</h5>
            </div>
        </div>
        <div class="flex-shrink-0 mt-sm-0 mt-3 fwefsa">
                <template v-for="(task, index) in tasks.filter((x) => x.status === 0)" >
                    

                    <template v-if="compareString(task.title, 'Create Purchase Order') || compareString(task.title, 'Create PO on remaining items')">
                        <template v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin') || hasPerm('add-purchase-order')">
                            <div class="flex-in pb-1">
                                <i class="ri-calendar-check-fill text-danger"></i>
                                <p class="mb-2"><span class="fw-semibold">{{primaryTaskPrefix}}</span> <span>
                                <a href="javascript:void(0);" class="btn btn-primary btn-sm" @click="createPOFromSO(order, orderQuotes, setNewPurchaseOrder)">
                                 {{task.title}}
                                </a>
                                </span></p>
                            </div>
                            
                        </template>
                        <template v-else> 
                          <div class="flex-in pb-1">
                                <i class="ri-calendar-check-fill text-danger"></i>
                                <p class="mb-2"><span class="fw-semibold">{{primaryTaskPrefix}}</span> <span>
                                
                                 {{task.title}}
                                
                                </span></p>
                            </div> 
                        </template>
                    </template>
                    <template v-else-if="compareString(task.title, 'Send Sales Order to customer')">

                            <div class="flex-in pb-1">
                                <i class="ri-calendar-check-fill text-danger"></i>
                                <p class="mb-2"><span class="fw-semibold">{{primaryTaskPrefix}}</span> <span>
                                <a href="javascript:void(0);" class="btn btn-primary btn-sm" @click="sendToCustomer()">{{task.title}}</a>
                                </span></p>
                            </div>

                        
                    </template>
                    <template v-else-if="compareString(task.title, 'Receive artwork and send to vendor')">
                            
                            <div class="flex-in pb-1">
                                <i class="ri-calendar-check-fill text-danger"></i>
                                <p class="mb-2"><span class="fw-semibold">{{primaryTaskPrefix}}</span> <span>
                                <a href="javascript:void(0);" class="btn btn-primary btn-sm" @click="artworkSampleRequiredEvent()">{{task.title}}</a>
                                </span></p>
                            </div>

                        
                    </template>
                    <template v-else-if="compareString(task.title, 'Send Purchase Order to vendor')">
                            
                            <div class="flex-in pb-1">
                                <i class="ri-calendar-check-fill text-danger"></i>
                                <p class="mb-2"><span class="fw-semibold">{{primaryTaskPrefix}}</span> <span>
                                <a href="javascript:void(0);" class="btn btn-primary btn-sm" @click="sendToVendor()">{{task.title}}</a>
                                </span></p>
                            </div>

                        
                    </template>
                    <template v-else-if="compareString(task.title, 'Get a ready date and set a follow up date')">
                            <div class="flex-in pb-1">
                                <i class="ri-calendar-check-fill text-danger"></i>
                                <p class="mb-2"><span class="fw-semibold">{{primaryTaskPrefix}}</span> <span>
                               <a href="javascript:void(0);" class="btn btn-primary btn-sm" @click="openGetAReadyDate(task, 'eta')">{{task.title}}</a>
                                </span></p>
                            </div>
                        
                    </template>
                    <template v-else-if="compareString(task.title, 'Confirm ready date')">
                            <div class="flex-in pb-1">
                                <i class="ri-calendar-check-fill text-danger"></i>
                                <p class="mb-2"><span class="fw-semibold">{{primaryTaskPrefix}}</span> <span>
                               <a href="javascript:void(0);" class="btn btn-primary btn-sm" @click="openGetAReadyDate(task, 'confirm')">{{task.title}}</a>
                                </span></p>
                            </div>
                        
                    </template>
                    <template v-else-if="compareString(task.title, 'Get Shipping Schedule')">
                            <div class="flex-in pb-1">
                                <i class="ri-calendar-check-fill text-danger"></i>
                                <p class="mb-2"><span class="fw-semibold">{{primaryTaskPrefix}}</span> <span>
                               <a href="javascript:void(0);" class="btn btn-primary btn-sm" @click="openGetAReadyDate(task, 'etd')">{{task.title}}</a>
                                </span></p>
                            </div>
                        
                    </template>
                    <template v-else-if="compareString(task.title, 'Sent deposit to vendor')">

                            <div class="flex-in pb-1">
                                <i class="ri-calendar-check-fill text-danger"></i>

                                <p class="mb-2"><span class="fw-semibold">Amount:</span> <span class="task-new">
                                <input type="text" v-on:keydown="checkDecimal($event, this)" v-model="order.deposit_sent_amount" placeholder="" class="form-control-sm">
                                </span></p>


                                <p class="mb-2"> <span >
                               <a href="javascript:void(0);" class="btn btn-primary btn-sm" @click="depositSent(task)">Deposit Sent</a>
                                </span></p>
                            </div>

                        
                    </template>
                    <template v-else-if="compareString(task.title, 'Factory to ship sample')">

                            <div class="flex-in pb-1">
                                <i class="ri-calendar-check-fill text-danger"></i>
                                <p class="mb-2"><span class="fw-semibold">{{task.title}}</span></p>

                                <p class="mb-2"><span class="fw-semibold">Tracking:</span> <span>
                                <input type="text" v-model="order.sample_tracking_no" placeholder="" class="form-control-sm">
                                </span></p>


                                <p class="mb-2"> <span>
                               <a href="javascript:void(0);" class="btn btn-primary btn-sm" @click="sampleShipped(task)">Sample shipped</a>
                                </span></p>
                            </div>

                        
                    </template>
                    <template v-else-if="compareString(task.title, 'Check for Air Freight')">

                        <div class="flex-in pb-1">
                            <i class="ri-calendar-check-fill text-danger"></i>
                            <p class="mb-2"><span class="fw-semibold">{{task.title}}:</span> <span>
                            <a href="javascript:void(0);" class="btn btn-primary btn-sm" @click="openCheckAirFreight(task)">{{task.title}}</a>
                            </span></p>
                        </div>

                         
                    </template>
                    <template v-else> 
                        <div class="flex-in pb-1">
                            <i class="ri-calendar-check-fill text-danger"></i>
                            <p class="mb-2"><span class="fw-semibold">{{primaryTaskPrefix}}</span> <span>
                            
                             {{task.title}}
                            
                            </span></p>
                        </div> 
                    </template>

                </template>
                
            <template v-if="taskType && taskType == 'po'">
                <template v-for="(task, index) in relatedTasks.filter((x) => x.status === 0)">
                    <div class="flex-in pb-1 tasklistrow">
                        <i class="ri-calendar-check-fill text-danger"></i>
                        <p class="mb-2"><span class="fw-semibold">{{secondaryTaskPrefix}}</span> <span>{{task.title}}</span></p>
                    </div>
                </template>
                

                
            </template>
            <template v-else>
                <template v-for="(po) in relatedTasks.filter((x) => x.tasks)">

                    <template v-for="(task, index) in po.tasks.filter((x) => x.status === 0)">
                        <div class="flex-in pb-1 tasklistrow">
                            <i class="ri-calendar-check-fill text-danger"></i>
                            <p class="mb-2"><span class="fw-semibold">{{secondaryTaskPrefix}}</span> <span>{{task.title}}</span></p>
                        </div>
                    </template>
                    
                </template>
            </template>
            
            <!-- <div class="flex-in pb-1">
                <i class="ri-calendar-check-fill text-danger"></i>
                <p class="mb-2"><span class="fw-semibold">PO Task:</span> <span>Proceed with production</span></p>
            </div>
            <div class="flex-in pb-1">
                <i class="ri-calendar-check-fill text-danger"></i>
                <p class="mb-2"><span>Check for Air freight</span> <button class="btn btn-primary btn-sm">Check for Air freight</button></p>
            </div>
            <div class="flex-in">
                <i class="ri-calendar-check-fill text-danger"></i>
                <p class="mb-2"><a href=""><span class="fw-semibold">PO Task:</span> <span>Approve PI from Vendor</span></a></p>
            </div> -->
        </div>
    </div>
    <hr class="mt-0 mb-2">
    <div class="mb-1 card-body">
        <div class="two-header">
            <div class="d-flex justify-content-between align-items-center has-line">
                <h5 class="card-title mb-01 text-success">Completed Tasks</h5>
            </div>
        </div>
        <div class="flex-shrink-0 mt-sm-0 mt-3 fwefsa" data-simplebar style="max-height: 220px; overflow: auto;">

            <template v-for="(task, index) in tasks.filter((x) => x.status === 1)">
                
                

                <template v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin')">

                    <div class="flex-in pb-2">
                         <i class="ri-calendar-check-fill text-success"></i>
                        <p class="mb-2"><a href="javascript:void(0)" @click="editTask(task)" title="Edit Task"><span class="fw-semibold">{{primaryTaskPrefix}}</span> 
                        <span>{{ task.title }}</span></a> 
                        <span>{{ task.completed_at ? formatDate(task.completed_at) : formatDate(task.updated_at) }}</span>
                        <br><span class="text-muted">By: 
                        <template v-for="(admin, adminIndex) in task.admins">
                                    <template v-if="adminIndex > 0">, </template>{{admin.name}}
                                </template>
                        </span>
                        </p>
                    </div>

                    
                </template>
                <template v-else>
                    <div class="flex-in pb-2">
                        <i class="ri-calendar-check-fill text-success"></i>
                        <p class="mb-2"><a href="javascript:void(0)"><span class="fw-semibold">{{primaryTaskPrefix}}</span> 
                        <span>{{ task.title }}</span></a> 
                        <span>{{ task.completed_at ? formatDate(task.completed_at) : formatDate(task.updated_at) }}</span>
                        <br><span class="text-muted">By: 
                        <template v-for="(admin, adminIndex) in task.admins">
                                    <template v-if="adminIndex > 0">, </template>{{admin.name}}
                                </template>
                        </span>
                        </p>
                    </div>

                    
                </template>
                <template v-if="compareString(task.title, 'Get Shipping Schedule')">

                    <div class="flex-in pb-2">
                        <i class="ri-calendar-check-fill text-success"></i>
                        <p class="mb-2"><a href="javascript:void(0)"><span class="fw-semibold">ETD: {{formatDate(task.etd)}}</span> 
                        <span>ETA: {{formatDate(task.eta)}}</span></a> 
                        <span>{{ task.completed_at ? formatDate(task.completed_at) : formatDate(task.updated_at) }}</span>
                        <br><span class="text-muted">By: 
                        <template v-for="(admin, adminIndex) in task.admins">
                                    <template v-if="adminIndex > 0">, </template>{{admin.name}}
                                </template>
                        </span>
                        
                        </p>
                    </div>

                    
                </template>
                


            </template>

            
            <template v-if="taskType && taskType == 'po'">
                <template v-for="(task, index) in relatedTasks.filter((x) => x.status === 1)">
                    <div class="flex-in pb-2">
                        <i class="ri-calendar-check-fill text-success"></i>
                        <p class="mb-2"><a href="javascript:void(0)">
                        <span class="fw-semibold">{{secondaryTaskPrefix}}</span> 
                        <span>{{task.title}}</span></a>
                        
                        </p>
                    </div>
                </template>
                
            </template>
            <template v-else>
                <template v-for="(po) in relatedTasks.filter((x) => x.tasks)">

                <template v-for="(task, index) in po.tasks.filter((x) => x.status === 1)">
                    <div class="flex-in pb-2">
                        <i class="ri-calendar-check-fill text-success"></i>
                        <p class="mb-2"><a href="javascript:void(0)">
                        <span class="fw-semibold">{{secondaryTaskPrefix}}</span> 
                        <span>{{task.title}}</span></a>
                        
                        </p>
                    </div>
                </template>
                
                </template>
            </template>
            

            
            <!-- <div class="flex-in pb-2">
                <i class="bx bx-task me-1 text-success"></i>
                <p class="mb-2"><a href=""><span class="fw-semibold">PO Task:</span> <span>Approve PI from Vendor</span></a> <span>09/21/2024</span><br><span class="text-muted">By: Suman Choudhury</span></p>
            </div>
            <div class="flex-in">
                <i class="bx bx-task me-1 text-success"></i>
                <p class="mb-2"><a href=""><span class="fw-semibold">PO Task:</span> <span>Approve PI from Vendor</span></a> <span>09/21/2024</span><br><span class="text-muted">By: Suman Choudhury</span></p>
            </div> -->
        </div>
    </div>
    <hr class="mt-0 mb-2">
    <div class="mb-1 card-body">
        <div class="two-header">
            <div class="d-flex justify-content-between align-items-center has-line">
                <h5 class="card-title mb-0">Label</h5>
                <a href="#" class="rtn-edit" data-toggle="modal" data-target="#editLabelModal"><i class="ri-edit-fill me-1"></i> Edit</a>
            </div>
        </div>
        <div class="flex-shrink-0 mt-sm-0 mt-3 fwefsa" v-if="order.labels">
            <template v-for="(label, index) in order.labels">
                <span class="me-2" :style="'color:' +label.color">{{label.name}}</span>
                
            </template>
            
            
        </div>
    </div>
</div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import axios from "axios";

export default {
    name: "OrderTask",
    props:['order', 'loading', 'taskType', 'bus', 'orderQuotes'],
    components: {},
    mounted() {
        //let self = this;
        this.primaryTaskPrefix = 'SO Task:';
        this.secondaryTaskPrefix = 'PO Task:';
        if(this.taskType && this.taskType == 'po') {
            this.primaryTaskPrefix = 'PO Task:';
            this.secondaryTaskPrefix = 'SO Task:';
        }
        this.bus.$on('triggerGetTasks', () => {
            this.getTasks();
        });
        /*$('#addTaskModal').on('hidden.bs.modal', function () {
            self.task = null;
        });*/
        this.syncLatestData();
        this.getTasks();
    },
    data() {
        return {
          tasks: [],
          relatedTasks: [],
          task: null,
          primaryTaskPrefix: '',
          secondaryTaskPrefix: '',
          toggleCompletedTaskList: false,
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
            'setNewPurchaseOrder'
        ]),
        openCheckAirFreight(task){
            this.$emit('openCheckAirFreightEvent', task);
        },
        depositSent(task){
            this.$emit('depositSentEvent', task);
        },
        sampleShipped(task){
            this.$emit('sampleShippedEvent', task);
        },
        openGetAReadyDate(task, dateType = 'eta'){
            this.$emit('openGetAReadyDateEvent', {task: task, dateType: dateType});
        },
        editTask(task) {
            this.$emit('openTaskEditEvent', task);
        },
        sendToVendor() {
            this.$emit('sendPOToVendorEvent');
        },
        changeEditMode() {
            this.$emit('editModeEvent');
        },
        sendToCustomer(){
            this.$emit('sendToCustomerEvent');
        },
        artworkSampleRequiredEvent(){
            this.$emit('artworkSampleRequiredEvent');
        },
        getTasks() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let url = window.route('orders.tasks.index', {id: this.order.id});
            if(this.taskType && this.taskType == 'po') {
                url = window.route('po.tasks.index', {id: this.order.id});
            }

            return axios.get(url, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.tasks = _.cloneDeep(data.data);
                        this.relatedTasks = _.cloneDeep(data.tasks);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        syncLatestData(){

        }
    },
    computed: {

    },
    watch: {
        'order': {
            handler: function (after, before) {
                this.syncLatestData();
            }
        }
    },
}
</script>

<style scoped>

</style>
